export default {
  // 问题分类
  className: 'problemClass',
  fields: [
    {
      name: 'sortNum',
      validators: [
        (value) => value ? null : '分类排序不可为空'
      ]
    },
    {
      name: 'name',
      validators: [
        (value) => value ? null : '分类名称不可为空',
        (val) => {
          if (val.length > 4) {
            return '分类名称不能超过四个字符'
          }
        }
      ]
    }
  ],
  search: [
    'name'
  ],
  action: {
    export: false
  }
}
